import { UseFormReturn } from 'react-hook-form';

import InvitationForm from './invitation-form';
import { TeamMembersTable } from './team-members-table';
import { type TeamMember, InviteFormValues } from '../types/team-types';
import { TEAM_MEMBER_STATUS } from '../types/team-enums';
import { TEAM_TAB } from '../types/use-team-filters-enums';

import { PageTabs } from '@/components/ui/page-tabs';

interface InviteMemberDialogTabsProps {
  form: UseFormReturn<InviteFormValues>;
  onSubmit: (data: InviteFormValues) => void;
  currentUserRole: TeamMember['role'] | null;
  teamMembers?: TeamMember[];
  // Team management functions and state
  onRoleChange: (memberId: string | number, newRole: TeamMember['role']) => void;
  onResendInvite: (memberId: string | number) => void;
  onCancelInvite: (memberId: string | number) => void;
  onDeleteMember: (memberId: string | number) => void;
  isLoading?: boolean;
  isError?: boolean;
  error?: Error | null;
}

export default function InviteMemberDialogTabs({
  form,
  onSubmit,
  currentUserRole,
  teamMembers = [],
  onRoleChange,
  onResendInvite,
  onCancelInvite,
  onDeleteMember,
  isLoading = false,
  isError = false,
  error = null,
}: InviteMemberDialogTabsProps) {
  const pendingMembers = teamMembers.filter(member => member.status === TEAM_MEMBER_STATUS.PENDING);

  return (
    <PageTabs.Root defaultValue="invite" className="w-full">
      <PageTabs.List aria-label="Invite member">
        <PageTabs.Tab value="invite">Invite New</PageTabs.Tab>
        <PageTabs.Tab value="pending">Pending</PageTabs.Tab>
      </PageTabs.List>

      <PageTabs.Panel value="invite" className="mb-6 space-y-4">
        <InvitationForm form={form} onSubmit={onSubmit} currentUserRole={currentUserRole} />
      </PageTabs.Panel>

      <PageTabs.Panel value="pending" className="mb-6 space-y-4">
        <TeamMembersTable
          members={pendingMembers}
          activeFilterStatus={TEAM_TAB.PENDING}
          isLoading={isLoading}
          isError={isError}
          error={error}
          onRoleChange={onRoleChange}
          onResendInvite={onResendInvite}
          onCancelInvite={onCancelInvite}
          onDeleteMember={onDeleteMember}
          currentUserRole={currentUserRole}
        />
      </PageTabs.Panel>
    </PageTabs.Root>
  );
}
